import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useGetFiltersInfo from '../hooks/useGetFiltersInfo';
import OptionsSelector from '../ui/OptionsSelector';

const TractionControlFilter = ({ type }) => {
  const {
    data, prevData, params, updateParams,
  } = useGetFiltersInfo();
  const { t } = useTranslation('search');

  const options = data?.tractionControls || prevData?.tractionControls || [];

  const onChange = (value) => {
    updateParams({
      tractions: value,
      page: 1,
    });
  };

  return (
    <OptionsSelector
      id="traction-control-filter"
      onChange={onChange}
      options={options}
      placeholder={t('Search')}
      type={type}
      value={params.tractions}
    />
  );
};

TractionControlFilter.propTypes = {
  type: PropTypes.string.isRequired,
};

export default TractionControlFilter;
